module.exports = __webpack_public_path__ + "static/media/Confused.23068db4.png";